import AxiosBackend from "@/config/backend-service";
import Axios from "@/config/customer-service";
import store from "@/store";
import { provinces } from "../config/location/provinces.js";
import { districts } from "../config/location/districts.js";
import { sub_districts } from "../config/location/sub_districts.js";

function detectReferrer(mode) {
    const friend = store?.state?.friend;
    const platform = friend?.platform || null;
    let referrer = "Website";
    const document_referrer = document.referrer;
    // console.log(document_referrer)
    // alert(document_referrer)
    // alert(1)
    if (document_referrer) {
        if (document_referrer?.includes("facebook")) {
            referrer = "Facebook";
        } else if (document_referrer?.includes("instagram")) {
            referrer = "Instagram";
        } else if (document_referrer?.includes("messenger")) {
            referrer = "Facebook";
        } else if (document_referrer?.includes("raw_platform=line")) {
            referrer = "Line";
        }
    }
    if (referrer == "Website") {
        const userAgent = navigator.userAgent;
        // console.log(userAgent)
        // alert(userAgent)
        const isFacebookBrowser = /FB_IAB|FBAN|Orca-Android/.test(userAgent);
        if (userAgent.includes("Line")) {
            referrer = "Line";
        } else if (isFacebookBrowser) {
            referrer = "Facebook";
        }
    }
    if (mode == "param") {
        referrer = platform || "Website";
    } else if (mode == "referrer") {
        // no action
    } else {
        if (platform) {
            referrer = platform;
        }
    }
    // alert(referrer)
    return referrer;
}

function detectBrowser() {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Line")) {
        return "LINE In-App Browser";
    } else if (userAgent.includes("Chrome")) {
        return "Google Chrome";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
        return "Safari";
    } else if (userAgent.includes("Firefox")) {
        return "Firefox";
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
        return "Internet Explorer";
    } else if (userAgent.includes("Edg")) {
        return "Microsoft Edge";
    } else {
        return "Unknown Browser";
    }
}

function allStorage() {
    let values = [];
    let keys = Object.keys(localStorage);

    for (let i = 0; i < keys.length; i++) {
        let detail = {
            key: keys[i],
            value: localStorage.getItem(keys[i]),
        }
        values.push(detail);
    }
    return values;
}

// ========== ========== For Line ========== ==========
function addParamAndReloadViaLine(to) {
    let check = 'none';
    const useLineBrowser = false;
    if (useLineBrowser) return check;
    const url = new URL(window.location.href);
    const browser = detectBrowser();
    const list = allStorage();
    const token = list.find(x => x.key == "token");
    const defaultSystem = store?.state?.defaultSystem;
    // const site = defaultSystem?.site;
    const customer = defaultSystem.customer;
    const toPath = to.fullPath;
    const watchListPage = [
        "/",
        "/checknumberLine",
        "/select-profile",
    ]
    if (token && customer?.code &&
        !watchListPage.includes(toPath)) {
        if (!url.searchParams.has("openExternalBrowser")) {
            if (browser == "LINE In-App Browser") {
                Axios.get("getProfile").then(({ data }) => {
                    if (data.status == "success") {
                        check = 'active';
                        url.searchParams.set("openExternalBrowser", "1");
                        url.searchParams.set("token", token.value);
                        url.searchParams.set("toPath", toPath);
                        url.searchParams.set("raw_platform", 'line');
                        url.searchParams.set("datetime", (new Date).getTime());
                        // ========== ========== SET_MULTI_PROFILE_SELECT ========== ==========
                        const multiProfileSelect = store?.state?.defaultSystem?.multiProfileSelect;
                        if (multiProfileSelect?.id) {
                            url.searchParams.set("multiProfileSelect", multiProfileSelect.id);
                        }
                        // ========== ========== ========== ==========
                        url.pathname = toPath;
                        window.location.href = url.toString();
                    }
                });
            }
        } else {
            if (url.searchParams.has("openExternalBrowser") && url.searchParams.has("token")) {
                if (browser != "LINE In-App Browser") {
                    check = 'active';
                    const paramToken = url.searchParams.get("token")
                    const paramToPath = url.searchParams.get("toPath")
                    localStorage.setItem("token", paramToken)
                    store.commit("defaultSystem/SET_USER", { role: "Customer" })
                    // ========== ========== SET_MULTI_PROFILE_SELECT ========== ==========
                    const multiProfileSelect = url.searchParams.get("multiProfileSelect")
                    if (multiProfileSelect) {
                        store.commit("defaultSystem/SET_MULTI_PROFILE_SELECT", { id: multiProfileSelect })
                    }
                    url.searchParams.delete("multiProfileSelect");
                    // ========== ========== ========== ==========
                    url.searchParams.delete("openExternalBrowser");
                    url.searchParams.delete("token");
                    url.searchParams.delete("toPath");
                    url.searchParams.delete("raw_platform");
                    url.searchParams.delete("datetime");
                    let pathname = toPath;
                    let search = "";
                    if (paramToPath && paramToPath != "/") {
                        const tempUrl = new URL(paramToPath, window.location.origin); // ใช้ชั่วคราวแยก
                        pathname = tempUrl.pathname;
                        search = tempUrl.search;
                    } else if (toPath == "/") {
                        pathname = "/main";
                    }
                    url.pathname = pathname;
                    url.search = search;
                    window.location.href = url.toString();
                }
            }
        }
    } else {
        if (url.searchParams.has("openExternalBrowser") && url.searchParams.has("token")) {
            check = 'active';
            const paramToken = url.searchParams.get("token")
            const paramToPath = url.searchParams.get("toPath")
            localStorage.setItem("token", paramToken)
            store.commit("defaultSystem/SET_USER", { role: "Customer" })
            // ========== ========== SET_MULTI_PROFILE_SELECT ========== ==========
            const multiProfileSelect = url.searchParams.get("multiProfileSelect")
            if (multiProfileSelect) {
                store.commit("defaultSystem/SET_MULTI_PROFILE_SELECT", { id: multiProfileSelect })
            }
            url.searchParams.delete("multiProfileSelect");
            // ========== ========== ========== ==========
            url.searchParams.delete("openExternalBrowser");
            url.searchParams.delete("token");
            url.searchParams.delete("toPath");
            url.searchParams.delete("raw_platform");
            url.searchParams.delete("datetime");
            let pathname = toPath;
            let search = "";
            if (paramToPath && paramToPath != "/") {
                const tempUrl = new URL(paramToPath, window.location.origin); // ใช้ชั่วคราวแยก
                pathname = tempUrl.pathname;
                search = tempUrl.search;
            } else if (toPath == "/") {
                pathname = "/main";
            }
            url.pathname = pathname;
            url.search = search;
            window.location.href = url.toString();
        }
    }
    // ========== ========== ========== ==========
    return check;
}
function reloadViaLine(to) {
    let check = 'none';
    const url = new URL(window.location.href);
    const browser = detectBrowser();
    const list = allStorage();
    const token = list.find(x => x.key == "token");
    const toPath = to.fullPath;
    // ========== ========== ========== ==========
    if (token) {
        return check;
    }
    // ========== ========== ========== ==========
    if (browser == "LINE In-App Browser") {
        check = 'active';
        url.searchParams.set("openExternalBrowser", "1");
        url.searchParams.set("toPath", toPath);
        url.searchParams.set("raw_platform", 'line');
        url.searchParams.set("datetime", (new Date).getTime());
        // ========== ========== ========== ==========
        url.pathname = toPath;
        window.location.href = url.toString();
    }
    // ========== ========== ========== ==========
    return check;
}
// ========== ========== ========== ==========

async function getCustomFingerprinting(hash) {
    let dataReturn = null;
    const fingerprint = {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screen: {
            width: screen.width,
            height: screen.height,
            colorDepth: screen.colorDepth,
        },
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        plugins: [...navigator.plugins].map(p => p.name).join(','),
    };
    dataReturn = { ...fingerprint };
    if (hash) {
        const raw = JSON.stringify(fingerprint);
        const hash = await sha256(raw); // ใช้ Web Crypto API ด้านล่าง
        dataReturn = { hash };
    }
    return dataReturn;
}
async function sha256(text) {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}
function generateBrowserFingerprint() {
    const browser = detectBrowser();
    const screenSize = window.screen.width + "x" + window.screen.height;

    // สร้าง fingerprint โดยการรวมข้อมูลและทำเป็น hash เบื้องต้น
    const fingerprint = `${browser}|${screenSize}`;
    return fingerprint;
}
function checkImage(url) {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
    });
}
function formatHtmlDetailDefault(value) {
    let html = value || "";
    if (html.includes("<iframe")) {
        html = html.replaceAll("<iframe", "<iframe style='max-width: 100%;'");
    }
    if (html.includes("<img")) {
        html = html.replaceAll(
            "<img",
            "<img style='max-width: 100%;width: auto !important;height: auto !important;'"
        );
    }
    // ========== ========== ========== ==========
    try {
        html = html?.replaceAll("<h1 ", "<h1 style='line-height: 1.5;' ");
        html = html?.replaceAll("<h2 ", "<h2 style='line-height: 1.5;' ");
        html = html?.replaceAll("<h3 ", "<h3 style='line-height: 1.5;' ");
        html = html?.replaceAll("<h4 ", "<h4 style='line-height: 1.5;' ");
    } catch (err) {
        console.log("formatHtmlDetail", err);
    }
    // ========== ========== ========== ==========
    try {
        html = html?.replaceAll("<h1>", "<h1 style='line-height: 1.5;'>");
        html = html?.replaceAll("<h2>", "<h2 style='line-height: 1.5;'>");
        html = html?.replaceAll("<h3>", "<h3 style='line-height: 1.5;'>");
        html = html?.replaceAll("<h4>", "<h4 style='line-height: 1.5;'>");
    } catch (err) {
        console.log("formatHtmlDetail", err);
    }
    return html;
}

async function logVisit(to, param) {
    try {
        let body = {
            "site_id": param?.site?.id || null,
            "page": to?.name || null,
            "employee_code": param?.customer?.code || null,
            "mission_id": null,
            "employee_mission_id": null,
            "reward_id": null,
            "blog_id": null,
            "mission_status": null,
            "mission_category": null,
            "reward_category": null,
            "delivery_status": null,
            "host": generateBrowserFingerprint(),
        }
        const visitLog = to?.meta?.visitLog;
        const params_map = visitLog?.params;
        const route_params = to?.params;
        if (params_map) {
            for (let key in params_map) {
                const value = params_map[key];
                const value_param = route_params[key];
                body[value] = value_param;
            }
        }

        // const test = true;
        // if (test) return;

        AxiosBackend.post("createEmployeeVisitLog", { ...body })
            .then((res) => {
                if (res) {
                    // console.log(res)
                }
            })
            .catch((err) => {
                console.log("createEmployeeVisitLog err :>> ", err);
            });
    } catch (err) { console.error("logVisit", err) }
}

async function getProfileNPS() {
    let response = null;
    try {
        response = await Axios.get("getProfileNPS")
    } catch (err) {
        console.log("getProfileNPS", err)
    }
    if (response) {
        const dataResponse = response.data;
        if (dataResponse.status == "success") {
            const userNps = store?.state?.defaultSystem?.userNps;
            const data = dataResponse?.data;
            let detail = {
                ...userNps,
                employee_id: data?.id || null,
                employee_code: data?.code || null,
                nps_alert: data?.nps_alert || false,
                nps_condition: data?.nps_condition || null,
                nps_condition_time: data?.nps_condition_time || null,
                nps_question_text: data?.nps_question_text || '',
                nps_is_use_comment_box: data?.nps_is_use_comment_box || false,
            }
            if (detail.nps_condition == 'app') {
                detail.nps_condition_time = detail.nps_condition_time || 5;
                if (detail.nps_timestamp == undefined) {
                    detail.nps_timestamp = new Date();
                }
            } else {
                delete detail['nps_timestamp'];
            }
            store.commit("defaultSystem/SET_USER_NPS", {
                ...detail,
                is_microsite: false,
            });
        }
    }
    return response;
}
async function exchangeTokenThirdParty(user_token, app_key) {
    if (!user_token || !app_key) { return null; }
    let returnData = null;
    let response = null;
    try {
        response = await AxiosBackend.post("exchangeTokenThirdParty", {
            user_token,
            app_key,
        })
    } catch (err) {
        console.log("exchangeTokenThirdParty", err)
    }
    if (response) {
        const dataResponse = response.data;
        if (dataResponse.status == "success") {
            const data = dataResponse.data;
            const token = data.access_token
            localStorage.setItem("token", token);
        }
    }
    return returnData;
}
function getLandingPage() {
    let landing_page = "main";
    const defaultSystem = store?.state?.defaultSystem;
    const site = defaultSystem?.site;
    const icon_menu_menu = site?.icon_menu?.menu || [];
    const model_landing_page = icon_menu_menu?.find((x) => x.is_landing_page);
    if (model_landing_page) {
        let name = model_landing_page.name;
        if (name == "account") {
            name = "my-account";
        } else if (name == "report") {
            name = "information-center-list";
        } else if (name == "campaign") {
            name = "campaign-list";
        } else if (name == "request") {
            name = "request-list";
        } else if (name == "warranty") {
            name = "warranty-list";
        }
        landing_page = name;
    }
    return landing_page;
}

// ========== ========== Color ========== ==========
function hexToHsl(hex) {
    // แปลง HEX เป็น RGB
    let r = parseInt(hex.slice(1, 3), 16) / 255;
    let g = parseInt(hex.slice(3, 5), 16) / 255;
    let b = parseInt(hex.slice(5, 7), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l;
    l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // Grayscale
    } else {
        const diff = max - min;
        s = l > 0.5 ? diff / (2 - max - min) : diff / (max + min);
        switch (max) {
            case r:
                h = (g - b) / diff + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / diff + 2;
                break;
            case b:
                h = (r - g) / diff + 4;
                break;
        }
        h /= 6;
    }

    return {
        h: Math.round(h * 360),
        s: Math.round(s * 100),
        l: Math.round(l * 100),
    };
}
function hslToHex(h, s, l) {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = (n) => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0"); // แปลงกลับเป็น HEX
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}
export function rgbaToHex(rgbaStr) {
    // ถ้าไม่ใช่ String หรือเป็นค่าว่าง ให้รีเซ็ตค่ากลับไป
    if (!rgbaStr || typeof rgbaStr !== 'string') return '';

    // ถ้าเป็น Hex อยู่แล้ว (ขึ้นต้นด้วย #) ให้ return ค่าเดิมกลับไปเลย
    if (rgbaStr.startsWith('#')) {
        return rgbaStr;
    }

    const match = rgbaStr.match(/[\d.]+/g);
    if (!match || match.length < 3) return '';

    const r = parseInt(match[0]);
    const g = parseInt(match[1]);
    const b = parseInt(match[2]);

    const toHex = (n) => n.toString(16).padStart(2, '0');

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
}
function adjustHslBrightness(hexColor, adjustment) {
    const hsl = hexToHsl(hexColor);
    hsl.l = Math.min(100, Math.max(0, hsl.l + adjustment)); // ปรับความสว่าง
    return hslToHex(hsl.h, hsl.s, hsl.l);
}
function getFontColorBasedOnBg(bgColor, mode) {
    // mode > bw, null
    let foreColor = "#FFFFFF";
    // แปลงสี Hex ให้เป็น RGB
    let r, g, b;

    if (bgColor.startsWith("#")) {
        // Remove # และแปลง Hex เป็น RGB
        const bigint = parseInt(bgColor.slice(1), 16);
        r = (bigint >> 16) & 255;
        g = (bigint >> 8) & 255;
        b = bigint & 255;
    } else if (bgColor.startsWith("rgb")) {
        // ถ้าเป็นรูปแบบ rgb() หรือ rgba()
        const rgbValues = bgColor.match(/\d+/g);
        r = parseInt(rgbValues[0], 10);
        g = parseInt(rgbValues[1], 10);
        b = parseInt(rgbValues[2], 10);
    }

    if (r) {
        // คำนวณ Luminance
        const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
        // เลือกสีฟอนต์
        foreColor = luminance > 190 ? "#000000" : "#FFFFFF"; // ถ้าสว่าง ใช้สีดำ, ถ้ามืด ใช้สีขาว
    }

    let raw = adjustHslBrightness(
        bgColor,
        foreColor === "#000000" ? -50 : 50
    );
    if (mode == "bw") {
        raw = foreColor;
    }

    return raw;
}
function blendColorWithWhite(hexColor, opacity) {
    // Ensure hexColor is a valid 6-character hex code
    if (hexColor.startsWith("#")) {
        hexColor = hexColor.slice(1);
    }

    // Convert the hex color to RGB
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);

    // Calculate the blended color with white
    const blend = (color) =>
        Math.round((1 - opacity) * 255 + opacity * color);

    const blendedR = blend(r);
    const blendedG = blend(g);
    const blendedB = blend(b);

    // Convert the blended RGB back to a hex string
    const toHex = (c) => c.toString(16).padStart(2, "0").toUpperCase();

    return `#${toHex(blendedR)}${toHex(blendedG)}${toHex(blendedB)}`;
}

// ========== ========== Microsite ========== ==========
function addClassQlEditorToSDDisplay() {
    setTimeout(() => {
        const elementsHTML = document.getElementsByClassName("sd-question--html");
        for (let element of elementsHTML) {
            const currentClasses = element.classList;
            if (!currentClasses.contains("ql-editor")) {
                element.classList.add("ql-editor");
            }
        }
    }, 500);
}
function visibilityTableHeaderQuestion(headers, data) {
    let visible_question_name_list = [];
    for (let item of data) {
        for (const key in item) {
            if (visible_question_name_list.includes(key)) {
                continue;
            }
            if (item[key]) {
                visible_question_name_list.push(key)
            }
        }
    }
    const default_header = [
        "createdAt",
        "point",
        "status",
        "point",
        "action",
    ];
    let new_headers = [];
    for (let item of headers) {
        if (
            visible_question_name_list.includes(item.value) ||
            default_header.includes(item.value)
        ) {
            new_headers.push(item)
        }
    }
    return new_headers;
}
function visibilityDialogDetailQuestion(data) {
    const default_header = [
        "createdAt",
        "fullname",
        "phone",
        "Point",
        "Status",
        "Status Detail",
    ];
    let new_data = [];
    for (let item of data) {
        if (
            default_header.includes(item.header) ||
            item.value
        ) {
            new_data.push(item)
        }
    }
    return new_data;
}

// ========== ========== SurveyJS ========== ==========
function formatQuestion(question, schema) {
    let label = "";
    let elements = schema?.elements || null;
    const pages = schema?.pages;
    if (Array.isArray(pages) && pages.length > 0 && !elements) {
        elements = [];
        for (let page of pages) {
            const _elements = page.elements;
            if (Array.isArray(_elements)) {
                elements = [...elements, ..._elements]
            }
        }
    }
    if (Array.isArray(elements)) {
        const model = elements.find((x) => x.name == question);
        if (model) {
            label = model.title || model.name;
        }
    }
    return label;
}
function formatFlatQuestion(schema) {
    let elements = schema?.elements || null;
    const pages = schema?.pages;
    if (Array.isArray(pages) && pages.length > 0 && !elements) {
        elements = [];
        for (let page of pages) {
            const _elements = page.elements;
            if (Array.isArray(_elements)) {
                elements = [...elements, ..._elements]
            }
        }
    }
    return elements || [];
}
function formatDetail(detail, question, schema) {
    let label = "";
    let elements = schema?.elements;
    const pages = schema?.pages;
    if (Array.isArray(pages) && pages.length > 0 && !elements) {
        elements = [];
        for (let page of pages) {
            const _elements = page.elements;
            if (Array.isArray(_elements)) {
                elements = [...elements, ..._elements]
            }
        }
    }
    if (Array.isArray(elements)) {
        const model = elements.find((x) => x.name == question);
        if (model) {
            label = detail;
            // ========== ========== [radiogroup,checkbox,dropdown,ranking,imagepicker] ========== ==========
            if (Array.isArray(model.choices)) {
                if (model.type == "imagepicker") {
                    let label_analyze = [];
                    if (!Array.isArray(label)) {
                        label_analyze = [label];
                    } else {
                        label_analyze = [...label];
                    }
                    let _label = [];
                    for (let item of label_analyze) {
                        const choice = model.choices.find((x) => {
                            return x.value != undefined ? x.value == item : x == item;
                        });
                        const value = choice?.imageLink || "";
                        if (value) {
                            _label.push({
                                content: value,
                            });
                        }
                    }
                    label = [..._label];
                } else {
                    if (Array.isArray(label)) {
                        let _label = [];
                        for (let item of label) {
                            const choice = model.choices.find((x) => {
                                return x.value != undefined ? x.value == item : x == item;
                            });
                            const value = choice?.text || choice || "";
                            if (value) {
                                _label.push(value);
                            }
                        }
                        label = _label.join(", ");
                    }
                }
            } else if (model.type == "boolean") {
                label = label ? model.labelTrue || "Yes" : model.labelFalse || "No";
            }
        }
    }
    return label;
}
function checkTypeQuestion(question, schema) {
    let type = "text";
    const elements = schema?.elements;
    if (Array.isArray(elements)) {
        const model = elements.find((x) => x.name == question);
        if (model?.type == "file" || model?.type == "imagepicker") {
            type = "image";
        }
    }
    return type;
}
function transformValueSurvey(value, question) {
    if (question.type === "boolean") {
        if (value != undefined) {
            value = value
                ? question.labelTrue || "Yes"
                : question.labelFalse || "No";
        } else {
            value = null;
        }
    }
    // ========== ========== ========== ==========
    if (question.type === "rating") {
        if (Array.isArray(question.rateValues)) {
            const modelRateValue = question.rateValues.find(
                (x) => x.value === value
            );
            value = modelRateValue?.text || value;
        }
    }
    // ========== ========== ========== ==========
    if (question.type === "radiogroup" || question.type === "dropdown") {
        if (value != undefined && !`${value}`.startsWith("other")) {
            const questionName = question.name;
            let choices = question.choices || [];
            // ========== ========== Address ========== ==========
            if (questionName == "province") {
                choices = provinces.map((x) => {
                    return {
                        value: x.id,
                        text: x.name_th,
                    };
                });
            }
            if (questionName == "district") {
                choices = districts.map((x) => {
                    return {
                        value: x.id,
                        text: x.name_th,
                    };
                });
            }
            if (questionName == "sub_district") {
                choices = sub_districts.map((x) => {
                    return {
                        value: x.id,
                        text: x.name_th,
                    };
                });
            }
            if (questionName == "zip_code") {
                for (let model of sub_districts) {
                    for (let item of model.zip_codes) {
                        choices.push({
                            value: `${model.id}_${item}`,
                            text: `${item}`,
                        });
                    }
                }
            }
            // ========== ========== ========== ==========
            const choice = choices?.find((x) => x.value == value || x == value);
            value = choice?.text || choice || "";
        } else {
            value = value ? value : null;
        }
    }
    // ========== ========== ========== ==========
    if (question.type === "checkbox") {
        let ans = [];
        if (Array.isArray(value)) {
            for (let item of value) {
                if (`${item}`.startsWith("other")) {
                    ans.push(item);
                } else {
                    const choice = question.choices?.find(
                        (x) => x.value == item || x == item
                    );
                    const _value = choice?.text || choice;
                    ans.push(_value);
                }
            }
        }
        value = ans.join(", ");
    }
    // ========== ========== ========== ==========
    if (question.type === "file") {
        if (value) {
            value = {
                type: "file",
                content: value,
            };
        }
    }
    // ========== ========== ========== ==========
    if (question.type === "imagepicker") {
        const choice = question.choices.find((x) =>
            x.value != undefined ? x.value == value : x == value
        );
        if (choice?.imageLink) {
            value = {
                type: "image",
                value: choice?.value,
                text: choice?.value,
                content: choice?.imageLink,
            };
        }
    }
    // ========== ========== ========== ==========
    if (question.type === "ranking") {
        let ans = [];
        if (Array.isArray(value)) {
            for (let item of value) {
                const choice = question.choices.find(
                    (x) => x.value == item || x == item
                );
                const _value = choice?.text || choice;
                ans.push(_value);
            }
        } else {
            for (let item of question.choices) {
                const _value = item?.text || item;
                ans.push(_value);
            }
        }
        value = ans.join(", ");
    }
    // ========== ========== ========== ==========
    if (question.type === "image") {
        if (question?.imageLink) {
            value = {
                type: "image",
                content: question?.imageLink,
            };
        }
    }
    return value;
}
function addDivCustomInputMaskPattern(questionEl, prefix) {
    if (!questionEl) return;

    const inputEl = questionEl.querySelector("input.sd-input");
    const contentContainer = questionEl.querySelector(".sd-question__content");

    if (inputEl && contentContainer && !questionEl.querySelector(".custom-prefix-wrapper")) {
        // 1. สร้าง Wrapper และ Container สำหรับ Prefix
        const wrapper = document.createElement("div");
        wrapper.className = "custom-prefix-wrapper";
        wrapper.style.display = "flex";
        wrapper.style.alignItems = "center";
        wrapper.style.width = "100%";
        wrapper.style.position = "relative";

        const prefixEl = document.createElement("span");
        prefixEl.className = "custom-prefix-badge";
        prefixEl.innerText = prefix;
        prefixEl.style.padding = "0 0 0 12px";
        prefixEl.style.fontWeight = "bold";
        prefixEl.style.color = "#555";
        prefixEl.style.userSelect = "none";
        prefixEl.style.pointerEvents = "none"; // ป้องกันไม่ให้เมาส์คลิกติดตัว Prefix
        prefixEl.style.position = "absolute";
        prefixEl.style.left = "0";
        prefixEl.style.zIndex = "1";

        // 2. จัดโครงสร้าง DOM ใหม่
        inputEl.parentNode.insertBefore(wrapper, inputEl);
        wrapper.appendChild(prefixEl);
        wrapper.appendChild(inputEl);

        // 3. บังคับ Browser Reflow / ใช้ setTimeout อ่านขนาดจริงหลัง Render
        setTimeout(() => {
            // ดึงความกว้างจริงของ Element รวม Padding ข้างใน span
            const exactWidth = prefixEl.getBoundingClientRect().width;

            // เผื่อ Margin ช่องว่างระหว่าง Prefix กับ Text ใน Input นิดหน่อย (เช่น 4px)
            const offsetGap = 4;

            // กำหนด paddingLeft ด้วย pixel จริง
            inputEl.style.paddingLeft = `${Math.ceil(exactWidth + offsetGap)}px`;
        }, 500);
    }
}
function transformJsonCustomInputMask(schema) {
    let pages = schema?.pages || [];
    const setData = (elements) => {
        if (Array.isArray(elements)) {
            for (let element of elements) {
                if (element.maskType == 'pattern') {
                    const maskSettings = element.maskSettings || null
                    const pattern = maskSettings?.pattern || null
                    if (pattern) {
                        const is_custom = isCustomInputMaskPattern(pattern);
                        if (is_custom) {
                            const _customPrefix = getCustomInputMaskPattern(pattern);
                            element._originalPattern = pattern;
                            element._customPrefix = _customPrefix;
                            delete element['maskType'];
                            delete element['maskSettings'];
                        } else {
                            element.maskSettings.saveMaskedValue = true;
                        }
                    }
                }
            }
        }
        return elements;
    };
    if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
            let elements = item?.elements || [];
            elements = setData(elements);
            if (item) {
                item.elements = elements;
            }
        }
        if (schema) {
            schema.pages = pages;
        }
    } else {
        let elements = schema?.elements || [];
        elements = setData(elements);
        if (schema) {
            schema.elements = elements;
        }
    }
    return schema;
}
function isCustomInputMaskPattern(pattern) {
    if (!pattern) return false;

    // Regex นี้จะดักจับ 9, a, หรือ # ที่ *ไม่มี* \ นำหน้า
    // (?<!\\) คือ Negative Lookbehind บอกว่าข้างหน้าต้องไม่ใช่ \
    const unescapedMaskTokenRegex = /(?<!\\)[9a#]/;

    // ถ้าเจอ Unescaped Mask Token แสดงว่าเป็น SurveyJS Standard Mask (คืนค่า false)
    // ถ้าไม่เจอเลย แสดงว่าเป็น Custom Prefix ล้วนๆ (คืนค่า true)
    return !unescapedMaskTokenRegex.test(pattern);
}
function getCustomInputMaskPattern(pattern) {
    // Function สำหรับถอด Backslash ออกเพื่อเอาข้อความ Prefix ตัวจริงไปใช้
    if (!pattern) return "";
    // แปลง \9 -> 9, \a -> a, \# -> #
    return pattern.replace(/\\(.)/g, "$1");
}
function formattedForSave(schema, json) {
    const data = { ...json };
    let pages = schema?.pages || [];
    let _elements = [];
    if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
            _elements = [
                ..._elements,
                ...(item?.elements || [])
            ]
        }
    } else {
        _elements = [
            ..._elements,
            ...(schema?.elements || [])
        ]
    }
    for (let element of _elements) {
        if (element._customPrefix) {
            const prefix = element._customPrefix;
            const val = data[element.name];
            if (val && !String(val).startsWith(prefix)) {
                data[element.name] = prefix + val;
            }
        }
    }
    return data;
}
function addDropdownPhoneCountry(questionEl, countryList, defaultCountry = 'TH') {
    if (!questionEl || !countryList || countryList.length === 0) return;

    const inputEl = questionEl.querySelector("input.sd-input");
    const contentContainer = questionEl.querySelector(".sd-question__content");

    if (inputEl && contentContainer && !questionEl.querySelector(".custom-prefix-wrapper")) {
        // สร้าง Wrapper สำหรับครอบ Select และ Input
        const wrapper = document.createElement("div");
        wrapper.className = "custom-prefix-wrapper";
        wrapper.style.display = "flex";
        wrapper.style.alignItems = "center";
        wrapper.style.width = "100%";
        wrapper.style.position = "relative";

        // สร้าง <select> สำหรับเลือกประเทศ
        const selectEl = document.createElement("select");
        selectEl.className = "custom-country-select";
        selectEl.style.position = "absolute";
        selectEl.style.maxWidth = "160px";
        selectEl.style.left = "12px";
        selectEl.style.zIndex = "2";
        selectEl.style.border = "none";
        selectEl.style.background = "transparent";
        selectEl.style.outline = "none";
        selectEl.style.cursor = "pointer";
        selectEl.style.fontSize = "14px";
        selectEl.style.fontWeight = "500";
        selectEl.style.color = "#333";
        selectEl.style.paddingRight = "8px";
        // ซ่อนข้อความส่วนเกินและใส่ ... (Ellipsis)
        selectEl.style.whiteSpace = "nowrap";
        selectEl.style.overflow = "hidden";
        selectEl.style.textOverflow = "ellipsis";
        // (สำคัญ) ปรับ Appearance เพื่อให้เบราว์เซอร์ยอมตัดคำเป็น ...
        selectEl.style.webkitAppearance = "none"; // ปล่อยพื้นที่ให้ตัดคำได้
        selectEl.style.mozAppearance = "none";
        selectEl.style.appearance = "none";

        // วนลูปสร้าง <option> จาก countryList
        countryList.forEach((c) => {
            const option = document.createElement("option");
            option.value = c.code;

            // 1. ข้อความยาวสำหรับตอนกดกางเลือก (Dropdown List)
            option.textContent = `${c.flag} ${c.name} (${c.dialCode})`;

            // 2. ฝากข้อความแบบสั้นไว้ใน dataset สำหรับตอนเลือกเสร็จแล้ว
            option.dataset.shortLabel = `${c.flag} (${c.dialCode})`; // เช่น 🇹🇭 (+66)
            option.dataset.fullLabel = `${c.flag} ${c.name} (${c.dialCode})`; // เก็บชื่อเต็มไว้ด้วย
            option.dataset.dialCode = c.dialCode;
            option.dataset.flag = c.flag;

            if (c.code === defaultCountry) {
                option.selected = true;
            }
            selectEl.appendChild(option);
        });

        // จัดโครงสร้าง DOM ใหม่
        inputEl.parentNode.insertBefore(wrapper, inputEl);
        wrapper.appendChild(selectEl);
        wrapper.appendChild(inputEl);


        // ========== ========== Event Handle ========== ==========
        const updateSelectDisplay = () => {
            // คืนค่าข้อความเต็มให้ทุก Option ก่อน (เผื่อเวลาผู้ใช้กดเปิด Dropdown ดูอีกครั้ง)
            Array.from(selectEl.options).forEach((opt) => {
                if (opt.dataset.fullLabel) {
                    opt.textContent = opt.dataset.fullLabel;
                }
            });

            // สลับเฉพาะ Option ที่เลือกอยู่ ณ ปัจจุบัน ให้แสดงเป็นแบบสั้น!
            const selectedOption = selectEl.options[selectEl.selectedIndex];
            if (selectedOption && selectedOption.dataset.shortLabel) {
                selectedOption.textContent = selectedOption.dataset.shortLabel;
            }

            let exactWidth = selectEl.getBoundingClientRect().width;
            if (selectedOption) {
                const text = selectedOption.textContent; // ตอนนี้จะได้ข้อความสั้น เช่น "🇹🇭 (+66)"
                const textWidth = 7;
                const extraSpacing = 4;
                exactWidth = Math.ceil((text.length * textWidth) + extraSpacing);
                selectEl.style.width = `${exactWidth}px`;
            }

            const offsetGap = 8;
            inputEl.style.paddingLeft = `${Math.ceil(exactWidth + offsetGap)}px`;

            window.removeEventListener("click", handleOutsideClick);
            window.removeEventListener("touchstart", handleOutsideClick);
        };
        const setToShortLabel = () => {
            const selectedOption = selectEl.options[selectEl.selectedIndex];
            if (selectedOption && selectedOption.dataset.shortLabel) {
                selectedOption.textContent = selectedOption.dataset.shortLabel;
            }
            updateSelectDisplay();
        };
        const setToFullLabel = () => {
            Array.from(selectEl.options).forEach((opt) => {
                if (opt.dataset.fullLabel) {
                    opt.textContent = opt.dataset.fullLabel;
                }
            });
        };
        const handleCloseAndDetach = () => {
            setToShortLabel();
        };
        const handleOutsideClick = (e) => {
            if (e.target !== selectEl) {
                handleCloseAndDetach();
            }
        };
        const handleOpenSelectOptions = () => {
            setToFullLabel();
        };
        selectEl.addEventListener("mousedown", handleOpenSelectOptions);
        selectEl.addEventListener("touchstart", handleOpenSelectOptions);
        selectEl.addEventListener("focus", () => {
            setToFullLabel();
            setTimeout(() => {
                window.addEventListener("click", handleOutsideClick);
                window.addEventListener("touchstart", handleOutsideClick);
            }, 0);
        });
        selectEl.addEventListener("blur", () => {
            setToShortLabel();
        });
        selectEl.addEventListener("change", () => {
            const selectedOption = selectEl.options[selectEl.selectedIndex];
            questionEl.dataset.selectedCountry = selectEl.value;
            questionEl.dataset.selectedDialCode = selectedOption.dataset.dialCode;

            setToShortLabel();

            // Trigger 'input' event บน inputEl เพื่อให้ SurveyJS รับรู้ความเปลี่ยนแปลง
            inputEl.dispatchEvent(new Event("input", { bubbles: true }));
        });

        const initialOption = selectEl.options[selectEl.selectedIndex];
        questionEl.dataset.selectedCountry = selectEl.value;
        questionEl.dataset.selectedDialCode = initialOption ? initialOption.dataset.dialCode : "+66";

        // รอ Browser Reflow เพื่อคำนวณขนาดจริง
        setTimeout(() => {
            setToShortLabel();
        }, 100);
    }
}
function customThemeSurveyJS(cssVariables) {
    // Remove
    const styleId = "custom-style-surveyjs";
    const existingStyle = document.getElementById(styleId);
    if (existingStyle) {
        existingStyle.remove();
    }
    if (!cssVariables) {
        return;
    }
    const primary = cssVariables["--sjs-primary-backcolor"];
    const hexColorPrimary = primary ? rgbaToHex(primary) : "#19B394";
    const fontColorPrimary = getFontColorBasedOnBg(hexColorPrimary, "bw");
    const questionpanel = cssVariables["--sjs-questionpanel-backcolor"];
    const hexColorQuestion = questionpanel ? rgbaToHex(questionpanel) : "#FFFFFF";
    const fontColorQuestion = getFontColorBasedOnBg(hexColorQuestion, "bw");
    // Add
    let secondaryColorQuestion = adjustHslBrightness(hexColorQuestion, -5);
    if (fontColorQuestion.toUpperCase() == '#FFFFFF') {
        secondaryColorQuestion = adjustHslBrightness(hexColorQuestion, 20);
    }
    let secondaryColorPrimary = adjustHslBrightness(hexColorQuestion, -5);
    if (fontColorPrimary.toUpperCase() == '#FFFFFF') {
        secondaryColorPrimary = adjustHslBrightness(hexColorPrimary, 20);
    }
    let highLightColorPrimary = hexColorPrimary;
    if (highLightColorPrimary.toUpperCase() == '#FFFFFF') {
        highLightColorPrimary = secondaryColorPrimary;
    }
    const highLightFontColorPrimary = getFontColorBasedOnBg(highLightColorPrimary, "bw");
    const customStyle = document.createElement("style");
    customStyle.id = styleId;
    customStyle.innerHTML = `
        .sd-item__control:focus + .sd-item__decorator {
        /* สีพื้นหลังของ Radio, Check ที่เลือก ขณะที่ Focus */
        background: ${secondaryColorQuestion};
        }
        .sd-item--checked .sd-item__decorator {
        /* สีพื้นหลังของ Radio, Check ที่เลือก */
        background: ${secondaryColorQuestion};
        }
        .sd-radio--checked .sd-radio__decorator:after {
        /* สีจุดของ Radio ที่เลือก */
        background: ${highLightColorPrimary == secondaryColorQuestion ? hexColorQuestion : highLightColorPrimary};
        }
        .sd-checkbox--checked .sd-checkbox__svg use {
        /* สีไอคอน Check */
        fill: ${highLightColorPrimary == secondaryColorQuestion ? hexColorQuestion : highLightColorPrimary};
        }

        .sd-rating__item--selected .sd-rating__item-text.sd-rating__item-text {
        /* สีข้อความ Rating ที่เลือก */
        color: ${highLightColorPrimary == hexColorQuestion ? fontColorQuestion : highLightFontColorPrimary};
        }
        .sd-rating__item--selected {
        /* สีพื้นหลัง Rating ที่เลือก */
        background: ${highLightColorPrimary == hexColorQuestion ? secondaryColorQuestion : highLightColorPrimary};
        }

        .sv-dropdown-popup .sv-list__item span {
        /* สีข้อความใน Dropdown */
        color: #000000;
        }
        .sv-dropdown-popup .sv-list__item.sv-list__item--selected .sv-list__item-body span,
        .sv-dropdown-popup .sv-list__item.sv-list__item--selected:hover .sv-list__item-body span,
        .sv-dropdown-popup .sv-list__item.sv-list__item--selected.sv-list__item--focused .sv-list__item-body span {
        /* สีข้อความใน Dropdown เมื่อถูกเลือก */
        color: ${fontColorPrimary};
        }

        .sd-boolean__thumb {
        /* สีข้อความ Boolean ที่เลือก */
        color: ${highLightFontColorPrimary};
        /* สีพื้นหลัง Boolean ที่เลือก */
        background: ${highLightColorPrimary};
        }

        .sd-imagepicker__check-icon {
        /* สีไอคอน ที่เลือก */
        fill: ${highLightColorPrimary};
        }

        .sv-ranking-item__index.sv-ranking-item__index {
        /* สีข้อความ */
        color: ${highLightColorPrimary == hexColorQuestion ? fontColorQuestion : highLightFontColorPrimary};
        /* สีพื้นหลัง */
        background: ${highLightColorPrimary == hexColorQuestion ? secondaryColorQuestion : highLightColorPrimary};
        }
    `;
    document.head.appendChild(customStyle);
}
// ========== ========== ========== ==========

export {
    addParamAndReloadViaLine,
    reloadViaLine,
    detectBrowser,
    logVisit,
    detectReferrer,
    getProfileNPS,
    exchangeTokenThirdParty,
    getLandingPage,
    getCustomFingerprinting,
    checkImage,
    formatHtmlDetailDefault,
    // ========== ========== Color ========== ==========
    hexToHsl,
    hslToHex,
    adjustHslBrightness,
    getFontColorBasedOnBg,
    blendColorWithWhite,
    // ========== ========== Microsite ========== ==========
    addClassQlEditorToSDDisplay,
    visibilityTableHeaderQuestion,
    visibilityDialogDetailQuestion,
    // ========== ========== SurveyJS ========== ==========
    formatQuestion,
    formatFlatQuestion,
    formatDetail,
    checkTypeQuestion,
    transformValueSurvey,
    addDivCustomInputMaskPattern,
    isCustomInputMaskPattern,
    getCustomInputMaskPattern,
    transformJsonCustomInputMask,
    formattedForSave,
    addDropdownPhoneCountry,
    customThemeSurveyJS,
    // ========== ========== ========== ==========
}